module.exports = __webpack_public_path__ + "img/ASL Securities mobile.77a3b678.png";